




import { Component, Mixins } from "vue-property-decorator";
import { DateDuration } from "../../../domain/system";
import { ModelEditableMixin } from "../../system/mixins";
import { StandardOption } from "../../system/selectors/mixins";
import PresettableDateDurationPicker from "../../system/selectors/PresettableDateDurationPicker.vue";
import { DocumentDurationOptionsSource } from "./options";

@Component({
  components: {
    PresettableDateDurationPicker,
  }
})
export default class DocumentDurationSelector extends Mixins(ModelEditableMixin) {
  get options(): StandardOption<DateDuration>[] {
    return DocumentDurationOptionsSource.options();
  }
}
